import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useLaunchParams } from "@telegram-apps/sdk-react";

import { PageLoader } from "@arc/ui/loader";

import { BankRoute } from "@/constants/routes";
import { useStartParamsParser } from "@/utils/hooks/useStartParamsParser";

import { Layout } from "../Layout";

// prettier-ignore
const appRoutes = {

  [BankRoute.index]: React.lazy(() => import("@/components/Bank").then((module) => ({ default: module.Bank }))),
  [BankRoute.tasks]: React.lazy(() => import("@/components/Bank").then((module) => ({ default: module.BankTasks }))),
  [BankRoute.stake]: React.lazy(() => import("@/components/Bank").then((module) => ({ default: module.BankStaking }))),
  [BankRoute.buy]: React.lazy(() => import("@/components/Bank").then((module) => ({ default: module.BankBuy }))),
  [BankRoute.history]: React.lazy(() => import("@/components/Bank").then((module) => ({ default: module.BankHistory }))),
  [BankRoute.referrals]: React.lazy(() => import("@/components/Bank").then((module) => ({ default: module.BankReferrals }))),

};
// prettier-ignore-end

export const MainRoutes = () => {
  const lp = useLaunchParams();

  useStartParamsParser(lp);

  return (
    <Routes>
      <Route element={<Layout platform={lp.platform} />}>
        {Object.entries(appRoutes).map(([path, Component]) => (
          <Route
            key={path}
            element={
              <Suspense fallback={<PageLoader />}>
                <Component />
              </Suspense>
            }
            path={path}
          />
        ))}

        <Route element={<Navigate to={BankRoute.index} />} path="*" />
      </Route>
    </Routes>
  );
};
